import React from 'react';

const PartNavigation = ({
    selectedPart,
    selectedPartIndex,
    totalParts,
    handlePartChange,
    baseSetName
}) => {
    if (!selectedPart) return null;

    let displayName = selectedPart.name;
    if (displayName === "Base" && baseSetName) {
        displayName = baseSetName.split('-')[0].trim();
    } else if (displayName.includes('-')) {
        displayName = displayName.split('-')[0].trim();
    }

    // Definiamo le icone come piccoli componenti SVG interni
    const ArrowLeftIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
        </svg>
    );

    const ArrowRightIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
        </svg>
    );

    return (
        <div className="d-flex justify-content-between align-items-center w-100 px-3 py-2" style={{ userSelect: 'none' }}>
            {/* Freccia Sinistra */}
            <div
                className="d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                onClick={() => handlePartChange('prev')}
            >
                <ArrowLeftIcon />
            </div>

            {/* Titolo Centrale */}
            <div className="text-center">
                <h2 className="m-0" style={{ fontSize: '24px', color: '#000', fontWeight: '700' }}>
                    {displayName}
                </h2>
                <span style={{ fontSize: '16px', color: '#888', fontWeight: '500' }}>
                    {selectedPartIndex + 1} / {totalParts}
                </span>
            </div>

            {/* Freccia Destra */}
            <div
                className="d-flex align-items-center justify-content-center"
                style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                onClick={() => handlePartChange('next')}
            >
                <ArrowRightIcon />
            </div>
        </div>
    );
};

export default PartNavigation;